import { Expose, Type } from 'class-transformer'
import { DocumentSnapshot } from 'firebase/firestore'
import { _FirebaseDocument, DocRef } from './Models'
import { TenantPlan } from './Tenant'

export enum PlanSwitchRequestStatus {
    REQUESTED = 'requested',
    PENDING = 'pending',
    DONE = 'done',
    FAILED = 'failed',
}

export class PlanSwitchRequest extends _FirebaseDocument {
    @Expose()
    public status: PlanSwitchRequestStatus = PlanSwitchRequestStatus.REQUESTED
    @Expose()
    public target_plan!: TenantPlan
    @Expose()
    public target_price_lookup_key?: string | null
    @Type(() => DocRef)
    @Expose()
    public checkout_session_request: DocRef | null = null
    @Expose()
    public error?: string | null
    @Expose()
    public payment_url?: string | null

    collection(): string {
        return `plan_switch_requests`
    }

    static fromFirebase(o: DocumentSnapshot): PlanSwitchRequest | null {
        return _FirebaseDocument._fromFirebase<PlanSwitchRequest>(PlanSwitchRequest, o)
    }
}


